import * as React from 'react';
import classNames from 'classnames';

import './styles.scss';
import Icon from '../Icon';

export interface ILoadingContentProps {
    /** Layouts to choose from */
    layout?: 'default' | 'inline' | 'absolute' | 'flex';
    /** Inline element size */
    size?: 'small' | 'large';
}

interface IState {
}

/**
 * Covers all while rendered. For example while loading content required for specific page.
 */
class LoadingContent extends React.Component<ILoadingContentProps, IState> {
    static displayName: string = 'LoadingContent';

    render () {
        return (
            <div className={classNames('loading-content', {
                absolute: this.props.layout === 'absolute' || !this.props.layout,
                inline: this.props.layout === 'inline',
                flex: this.props.layout === 'flex',
                small: !this.props.size || this.props.size === 'small',
                large: this.props.size === 'large',
            })}>
                <Icon width={16} height={16} kind="loading"/>
            </div>
        );
    }
}

export default LoadingContent;
